import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    header?: React.ReactNode;
    headerTag?: Parameters<typeof Text>[0]["as"];
    text?: React.ReactNode;
}

export const ResponsiveCardBody: React.FC<IProps> = ({header, headerTag, text, children}) => (
    <div className={wrapperStyle}>
        <div className={contentStyle}>
            {typeof header === "string" ? (
                <Text as={headerTag || "h4"} variant="headline_4" className={headerStyle}>
                    {header}
                </Text>
            ) : (
                header
            )}
            {text && (
                <Text variant="body_copy_2" className={textStyle}>
                    {text}
                </Text>
            )}
            {children}
        </div>
    </div>
);

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2,
    md: {
        alignItems: "center"
    }
});

const contentStyle = css({
    flex: "1 1",
    md: {
        paddingLeft: 2,
        paddingRight: 2
    }
});

const headerStyle = css({
    paddingBottom: 2
});

const textStyle = css({
    paddingBottom: 2
});
import React from "react";
import {css} from "@panda/css";

import {Text} from "@pg-design/text-module";

interface IProps {
    children: React.ReactNode;
    header?: React.ReactNode;
    headerTag?: Parameters<typeof Text>[0]["as"];
    text?: React.ReactNode;
}

export const ResponsiveCardBody: React.FC<IProps> = ({header, headerTag, text, children}) => (
    <div className={wrapperStyle}>
        <div className={contentStyle}>
            {typeof header === "string" ? (
                <Text as={headerTag || "h4"} variant="headline_4" className={headerStyle}>
                    {header}
                </Text>
            ) : (
                header
            )}
            {text && (
                <Text variant="body_copy_2" className={textStyle}>
                    {text}
                </Text>
            )}
            {children}
        </div>
    </div>
);

const wrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-start",
    padding: 2,
    md: {
        alignItems: "center"
    }
});

const contentStyle = css({
    flex: "1 1",
    md: {
        paddingLeft: 2,
        paddingRight: 2
    }
});

const headerStyle = css({
    paddingBottom: 2
});

const textStyle = css({
    paddingBottom: 2
});
